// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider_mlDnG {
  width: 100%;
  height: 1px;
  background-color: var( --color-base200 );
}

.textArea_vHnlr {
  min-height: 176px;
}

.inputCaption_mKKwE {
  color: var(--color-base500) !important;
}

.inputCaptionDanger_WLFew {
  color: var(--color-danger700) !important;
}

.resetEdits_NhgrD {
  align-self: flex-start;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/screens/PendingSaleMessage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".divider {\n  width: 100%;\n  height: 1px;\n  background-color: var( --color-base200 );\n}\n\n.textArea {\n  min-height: 176px;\n}\n\n.inputCaption {\n  color: var(--color-base500) !important;\n}\n\n.inputCaptionDanger {\n  color: var(--color-danger700) !important;\n}\n\n.resetEdits {\n  align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `divider_mlDnG`,
	"textArea": `textArea_vHnlr`,
	"inputCaption": `inputCaption_mKKwE`,
	"inputCaptionDanger": `inputCaptionDanger_WLFew`,
	"resetEdits": `resetEdits_NhgrD`
};
export default ___CSS_LOADER_EXPORT___;
